import React, { useEffect, useRef, useState } from 'react';
import './Industries.css';

const INDUSTRIES = [
  { num: '01', title: 'Fine Jewelry', text: 'In the realm of jewelry, we craft exquisite pieces that symbolize cherished moments, blending artistry and engineering with craftsmanship. We have several different brands, each with a focus on a different aspect of the jewelry market. From engagement rings and wedding bands to luxury fine jewelry and daily jewelry, our brands and collections offer timeless and durable pieces for each budget and taste.', img: 'https://cdn.prod.website-files.com/68234acd8fb1ab421a72b174/68249919c33b26ab3b45c0ad_HOMEPAGE-9SEPT-V8-v10.jpg' },
  { num: '02', title: 'Home Decor', text: 'Our home decor and textiles branch offers a minimalist, timeless aesthetic. With unique key pieces and elegant colorways, our pieces effortlessly lend themselves to a versatile use and endless color combinations, bringing a touch of sophistication to any room.', img: 'https://cdn.prod.website-files.com/68234acd8fb1ab421a72b174/6824546620fc65c2a96585d2_ChatGPT%20Image%20May%2014%2C%202025%2C%2011_29_11%20AM.png' },
  { num: '03', title: 'Print-on-Demand', text: 'Our engineer side meets our creative, artsy side in our print-on-demand signs, lighting up everywhere we go. By leveraging cutting-edge technology and great design, we create beautiful neon signs that cater to different needs, are easy to install and durable.', img: 'https://cdn.prod.website-files.com/68234acd8fb1ab421a72b174/6835b20adf9d66cbce57aa1e_67fe46e88c753e0b5d4684e7.jpg' },
  { num: '04', title: 'Sleep Gear', text: 'Blending our scientific know-how with beautiful design, we offer natural and effective sleep and self-care solutions for our busy, modern day customers. Our ultimate aim is to be the go-to address for all their sleep-related needs, creating a trusted and true brand that mobilizes people around the importance of quality rest.', img: 'https://cdn.prod.website-files.com/68234acd8fb1ab421a72b174/6826ea67d283d7912e33a7fe_30012025-URUNSTILLIFE05028.jpg' },
];

export default function Industries() {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <main className="industries">
      <section className="industries-hero">
        <div className="industries-hero__inner">
          <h1 className="industries-hero__title">Our Industries</h1>
          <p className="industries-hero__sub">
            Our brands engage in a vast array of industries, all tied together by a passion to
            engineer an end-to-end tailored, seamless and responsible shopping experience for our customers
          </p>
        </div>
      </section>

      <section className="industries-list">
        <div className="industries-list__inner">
          <div className="service-component">

            <div className="service-image-col">
              <div className="service-image-sticky">
                {INDUSTRIES.map((item, i) => (
                  <div
                    key={i}
                    className={`service-image-absolute ${hoveredIndex === i ? 'service-image-absolute--visible' : ''}`}
                  >
                    <div className="service-image-wrapper">
                      <img src={item.img} alt={item.title} className="service-image" loading="lazy" />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="service-content-col">
              {INDUSTRIES.map((item, i) => (
                <div
                  key={i}
                  className="service-component-wrapper"
                  onMouseEnter={() => setHoveredIndex(i)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                >
                  <div className="service-content-block">
                    <div className="service-top-content">
                      <div className="service-title-wrap">
                        <div className="service-title-item">
                          <div className={`service-title${hoveredIndex === i ? ' service-title--hovered' : ''}`}>
                            {item.title}
                            <sup className="service-number">{item.num}</sup>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`service-description-item${openIndex === i ? ' service-description-item--open' : ''}`}>
                      <p className="service-description-text">{item.text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>
    </main>
  );
}